export class UserInformation {
  locale: string;
}
